import { errorType } from "src/types/error-types";

export class ClientError {
  somethingWentWrong: errorType = {
    __typename: "Error",
    code: "FRT-999",
    message: "ระบบขัดข้อง",
  };
  somethingWentWrongWait1Minute: errorType = {
    __typename: "Error",
    code: "FRT-998",
    message: "ระบบขัดข้อง กรุณาลองอีกครั้ง ใน 1 นาที",
  };
  proxyBlock: errorType = {
    __typename: "Error",
    code: "FRT-997",
    message: "คุณดำเนินการถี่เกินไป กรุณาลองอีกครั้ง ใน 1 นาที",
  };
  connectionWentWrong: errorType = {
    __typename: "Error",
    code: "FRT-996",
    message: "การเชื่อมต่อขัดข้อง",
  };
  phoneNoMustStartWith0: errorType = {
    __typename: "Error",
    code: "FRT-000",
    message: "เบอร์โทรศัพท์ต้องเริ่มต้นด้วย 0",
  };
  swtichBrokerFail: errorType = {
    __typename: "Error",
    code: "FRT-001",
    message: "เปลี่ยน broker ไม่สำเร็จ",
  };
  bitkubRegisFail: errorType = {
    __typename: "Error",
    code: "FRT-002",
    message: "สมัคร Finnize สำหรับ Bitkub ไม่สำเร็จ",
  };
  bitkubApiInvalid: errorType = {
    __typename: "Error",
    code: "CLI-GW-062",
    message: "API-key หรือ API-Secret ไม่ถูกต้อง",
  };
  bitkubBestbidReqFail: errorType = {
    __typename: "Error",
    code: "FRT-003",
    message: "ไม่สามารถดึงข้อมูล ticker",
  };
  bitkubWrongCurrency: errorType = {
    __typename: "Error",
    code: "FRT-004",
    message: "สกุลเงิน ไม่ถูกต้อง",
  };
  loginFail: errorType = {
    __typename: "Error",
    code: "FRT-005",
    message: "เข้าสู่ระบบไม่สำเร็จ",
  };
  requestRegisPhoneNoFail: errorType = {
    __typename: "Error",
    code: "FRT-006",
    message: "เริ่มต้นขอสมัครไม่สำเร็จ",
  };
  missingBrokerID: errorType = {
    __typename: "Error",
    code: "FRT-007",
    message: "ไม่พบข้อมูล broker",
  };
  missingPhoneNo: errorType = {
    __typename: "Error",
    code: "FRT-008",
    message: "กรุณาใส่เบอร์โทรศัพท์ของท่าน",
  };
  invalidPhoneNo: errorType = {
    __typename: "Error",
    code: "FRT-009",
    message: "เบอร์โทรศัพท์ไม่ถูกต้อง",
  };
  requestResetPasswordFail: errorType = {
    __typename: "Error",
    code: "FRT-010",
    message: "เริ่มต้นขอรหัสผ่านไม่สำเร็จ",
  };
}

const clientError = new ClientError();
export default clientError;
